import React from 'react';

const pillStyles = {
  Compliant:     { bg: 'bg-emerald-50 border border-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  'Low Risk':    { bg: 'bg-emerald-50 border border-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  Low:           { bg: 'bg-emerald-50 border border-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  Completed:     { bg: 'bg-emerald-50 border border-emerald-100', text: 'text-emerald-700', dot: 'bg-emerald-500' },
  
  'In Progress': { bg: 'bg-blue-50 border border-blue-100',       text: 'text-blue-700',    dot: 'bg-blue-500' },
  Active:        { bg: 'bg-blue-50 border border-blue-100',       text: 'text-blue-700',    dot: 'bg-blue-500' },
  
  Overdue:       { bg: 'bg-amber-50 border border-amber-200',     text: 'text-amber-700',   dot: 'bg-amber-500' },
  Medium:        { bg: 'bg-amber-50 border border-amber-200',     text: 'text-amber-700',   dot: 'bg-amber-500' },
  'At Risk':     { bg: 'bg-amber-50 border border-amber-200',     text: 'text-amber-700',   dot: 'bg-amber-500' },
  'Medium Risk': { bg: 'bg-amber-50 border border-amber-200',     text: 'text-amber-700',   dot: 'bg-amber-500' },
  
  Critical:      { bg: 'bg-red-50 border border-red-200',         text: 'text-red-700',     dot: 'bg-red-500' },
  High:          { bg: 'bg-red-50 border border-red-200',         text: 'text-red-700',     dot: 'bg-red-500' },
  'High Risk':   { bg: 'bg-red-50 border border-red-200',         text: 'text-red-700',     dot: 'bg-red-500' },
  
  'Not Started': { bg: 'bg-slate-50 border border-slate-200',     text: 'text-slate-600',   dot: 'bg-slate-400' },
  'No Record':   { bg: 'bg-slate-50 border border-slate-200',     text: 'text-slate-600',   dot: 'bg-slate-400' },
  Draft:         { bg: 'bg-slate-50 border border-slate-200',     text: 'text-slate-600',   dot: 'bg-slate-400' },
};

const Pill = ({ status }) => {
  const s = pillStyles[status] || pillStyles['Not Started'];
  return (
    <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md text-[11px] font-semibold w-fit ${s.bg} ${s.text}`}>
      <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${s.dot}`} />
      {status}
    </span>
  );
};

export default Pill;